import { Component, OnInit, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { PaymentIntegration } from '../model/PaymentIntegration.model';

@Component({
  selector: 'app-razorpay-payment',
  templateUrl: './razorpay-payment.component.html',
  styleUrls: ['./razorpay-payment.component.scss']
})
export class RazorpayPaymentComponent implements OnInit {
  @Input() paymentIntegration:PaymentIntegration = new PaymentIntegration() ;
  @Input() name: any;
  @Input() contact: any;
  @Input() email: any;
  constructor() { }
  @ViewChild('paymentForm', {static: false}) paymentForm: ElementRef;
  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.test && !changes.test.isFirstChange()) {
      // exteranl API call or more preprocessing...
    }

    for (let propName in changes) {

      let change = changes[propName];

      if(change.currentValue != null && change.currentValue.orderId != undefined && change.currentValue.orderId != null) {

        setTimeout(() => {
          this.paymentForm.nativeElement.submit();
        }, 1000);

        break;

      }

    }

  }

}
